import { render } from "./Reset.vue?vue&type=template&id=532aa01c"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/reselect.konnektor.nl_acceptance/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.39_vue@3.2.39_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__